import { render, staticRenderFns } from "./ForgetPassWorld.vue?vue&type=template&id=7a55cd3d&scoped=true"
import script from "./ForgetPassWorld.vue?vue&type=script&lang=js"
export * from "./ForgetPassWorld.vue?vue&type=script&lang=js"
import style0 from "./ForgetPassWorld.vue?vue&type=style&index=0&id=7a55cd3d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a55cd3d",
  null
  
)

export default component.exports